import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'

@observer(['sources'])
export default class Sources extends Component {

  constructor(props) {
    super(props)

    this.props.sources.loadAllSources()
  }

  newSource(row) {
    this.props.sources.newSource(row.name)
  }

  updateSource(row, cellText, cellValue) {
    this.props.sources.updateSource(row.id, cellValue)
  }

  deleteSource(id) {
    if (confirm('Are you sure you want to delete this Source?')) {
      this.props.sources.deleteSource(id)
    }
  }

  formatActions(cell, row) {
    return <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteSource(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
  }

  render() {
    const options = {
      onAddRow: this.newSource.bind(this)
    }

    const sourcesTable = (
      <BootstrapTable
          data={ this.props.sources.data }
          striped={ true }
          hover={ true }
          pagination={ true }
          search={ true }
          exportCSV={ true }
          options={ options }
          insertRow={ true }
          bordered={ false }
          cellEdit={ { mode: 'click', blurToSave: false, afterSaveCell: this.updateSource.bind(this) } } >
        <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="name" dataSort={ true } editable={{ validator: Validators.validString }}>Name</TableHeaderColumn>
        <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
      </BootstrapTable>
    )

    return (
      <div>
        <Collapsible title="Sources" content={ sourcesTable } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/sources.js